/**
 * Generates an array of year options for select dropdowns.
 * Returns the most recent `count` years starting from the current year.
 */
export function generateYearOptions(count = 5): Array<{ label: string; value: string }> {
	const currentYear = new Date().getFullYear();
	return Array.from({ length: count }, (_, i) => {
		const year = (currentYear - i).toString();
		return { label: year, value: year };
	});
}

/**
 * Generates month options for select dropdowns.
 * For the current year, limits to months up to the current month.
 * For past years, returns all 12 months.
 */
export function generateMonthOptions(selectedYear: string): Array<{ label: string; value: string }> {
	const now = new Date();
	const monthCount = selectedYear === now.getFullYear().toString() ? now.getMonth() + 1 : 12;
	return Array.from({ length: monthCount }, (_, i) => ({
		label: new Date(2000, i).toLocaleString('default', { month: 'long' }),
		value: String(i + 1).padStart(2, '0'),
	}));
}
